<div class="offer-app">
  <div class="offer-app__content">
    <div class="offer-app__title offer-app__title-desktop">{{ 'mobile-apps-banner.title-desktop' | translate }}</div>
    <div class="offer-app__title offer-app__title-touch">{{ 'mobile-apps-banner.title-mobile' | translate }}</div>
    <div class="offer-app__text offer-app__text-desktop">{{ 'mobile-apps-banner.text-desktop' | translate }}</div>
    <div class="offer-app__text offer-app__text-touch">{{ 'mobile-apps-banner.text-mobile' | translate }}</div>
    <div class="offer-app__controls">
      <div class="offer-app__column">
        <div class="offer-app__control">
          <a [href]="appleLink" class="offer-app__app-link offer-app__app-link-ios">
            <img src="/img/offers/button-appstore.png" />
          </a>
        </div>
        <div class="offer-app__control">
          <a [href]="googleLink" class="offer-app__app-link offer-app__app-link-android">
            <img src="/img/offers/button-googleplay.png" />
          </a>
        </div>
        <div class="offer-app__control">
          <a [href]="huaweiLink" class="offer-app__app-link">
            <img src="/img/offers/button-appgallery.png" />
          </a>
        </div>
      </div>
      <div class="offer-app__column offer-app__column-qr">
        <div class="offer-app__control-qr">
          <img src="/img/offers/button-app-qr.png" />
        </div>
      </div>
      <div class="offer-app__column offer-app__column-qr-hint">
        <div class="offer-app__hint">
          <div class="offer-app__hint-text">{{ 'mobile-apps-banner.scan-qr' | translate }}</div>
          <div class="offer-app__hint-arrow"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="offer-app__img">
    <img src="/img/offers/offer_02.png"/>
  </div>
</div>
